export enum UserRole {
  ADMIN = "管理员",
  BA = "商务经理",
  CUSTOMER = "客户",
  WAREHOUSE_MANAGER = "仓库管理员",
  AUDITOR = "审核员",
  FINANCE = "财务员",
  SALESPERSON = "业务员",
  PARTNER = "合伙人",
  PURCHASER = "采购员",
}

/** Employee roles available in the create-staff form (excludes ADMIN, CUSTOMER). */
export const USER_ROLE_STAFF_CREATABLE: (keyof typeof UserRole)[] = [
  "BA",
  "WAREHOUSE_MANAGER",
  "AUDITOR",
  "FINANCE",
  "SALESPERSON",
  "PARTNER",
  "PURCHASER",
];

export enum OrderStatus {
  PLACED = "已下单",
  REVIEWED = "已审核",
  ENTERED = "仓库录入中",
  SHIPPED = "已发货",
  WAIT_SHIP = "已拦截",
  CANCELLED = "已取消",
}

export enum KdOrderStatus {
  NOT_REQUIRED = "无需上传",
  NOT_UPLOADED = "未上传",
  NOT_SUBMITTED = "未提交",
  SUBMITTED = "已提交",
}

export enum FieldType {
  NUMBER = "NUMBER",
  PERCENTAGE = "PERCENTAGE",
  TEXT = "TEXT",
  URL = "URL",
}

export enum SettlementTaskStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
}

export function getEnumObjectByValue(
  enumObj: any,
  value: string,
): string | null {
  for (const [k, v] of Object.entries(enumObj)) {
    if (v === value) {
      return k;
    }
  }
  return null;
}
